import { Box, Flex } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'
import React from 'react'
import DateUtil from 'src/lib/date-util'
import { getLocale } from 'src/config/globals'
import moment from 'moment-timezone'
const LOCALE = getLocale()

type Props = {
  monthlyCredits: number
  monthlyCreditsEndAt: string
  bundleCredits: number
  bundleCreditsEndAt: string
}

const CreditExpirationReminder: React.FC<Props> = ({
  monthlyCredits,
  monthlyCreditsEndAt,
  bundleCredits,
  bundleCreditsEndAt,
}) => {
  let creditsType = null
  let credits = null
  let referenceDate = null
  if (monthlyCredits > 0 && bundleCredits > 0 && monthlyCreditsEndAt && bundleCreditsEndAt) {
    let monthlyCreditsEndDate = DateUtil.dateFromISOString(monthlyCreditsEndAt)
    let bundleCreditsEndDate = DateUtil.dateFromISOString(bundleCreditsEndAt)
    referenceDate = monthlyCreditsEndDate < bundleCreditsEndDate ? monthlyCreditsEndDate : bundleCreditsEndDate
    credits = monthlyCreditsEndDate < bundleCreditsEndDate ? monthlyCredits : bundleCredits
    creditsType = monthlyCreditsEndDate < bundleCreditsEndDate ? 'monthly' : 'credit_bundle'
  } else if (monthlyCredits > 0 && monthlyCreditsEndAt) {
    referenceDate = DateUtil.dateFromISOString(monthlyCreditsEndAt)
    credits = monthlyCredits
    creditsType = 'monthly'
  } else if (bundleCredits > 0 && bundleCreditsEndAt) {
    referenceDate = DateUtil.dateFromISOString(bundleCreditsEndAt)
    // Only show the expiration reminder for bundle credits if there's at most 2 weeks left
    if (referenceDate < moment().add(2, 'w')) {
      credits = bundleCredits
      creditsType = 'credit_bundle'
    }
  }

  if (creditsType === null) {
    return null;
  }

  return (
    <Flex
      as="p"
      borderRadius="1,5x"
      justifyContent="flex-start"
      alignItems="center"
      px="1x"
      py="0,25x"
      variant="text.tinyTitle"
      backgroundColor="yellow92"
      borderColor="yellow65"
      borderStyle="solid"
      borderWidth="small"
    >
      {creditsType === 'monthly' && t(
        '%{liveLessonCount} monthly subscription credit |||| %{liveLessonCount} monthly subscription credits',
        { smart_count: credits, liveLessonCount: credits }
      )}
      {creditsType === 'credit_bundle' && t(
        '%{liveLessonCount} bundle credit |||| %{liveLessonCount} bundle credits',
        { smart_count: credits, liveLessonCount: credits }
      )}
      <Box as="span" fontWeight={400}>
        &nbsp;
        {t('expire %{timeLeft}', {
          timeLeft: referenceDate.fromNow(),
        })}
      </Box>
    </Flex>
  )
}
export default CreditExpirationReminder
